// React Thirty Party Library
import { message, Tabs } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useSelector, useDispatch, batch } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../constants";

// Components Library
import {
  SearchEmployee,
  DrawerAddEmployee,
  DrawerAddGroup,
} from "./components";
import { BtnSubmit, TableList } from "../../../../components";

// Handler Library
import { exportHDLR, tableHDLR } from "../../../../handlers";

// Services Library
import { TIME, REDUX as REDUX_UTIL } from "../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../services/redux/actions";

import { TableItems } from "./components/TableEmployee/items";

// Styles Library
import styles from "../../../../pages/index.module.css";

const { reduxStoreWrapper } = REDUX_UTIL;
const { parseExportTime } = TIME;
const { BTN_IMG } = TEMPLATE.BTN;
const { EMPLOYEE_SUMMARY_COL } = TEMPLATE.TABLEDATA.EMPLOYEE;
const { groupOptions, filterOptions } = TEMPLATE.EMPLOYEE;

const EmployeeList = (props) => {
  const { col } = props;
  const dispatch = useDispatch();

  const employees = useSelector(reduxStoreWrapper("employee.byID")) || {};
  const employeesCoid = useSelector(reduxStoreWrapper("employee.byCoid")) || {};
  const group = useSelector(reduxStoreWrapper("group.byID"));
  const company = useSelector(reduxStoreWrapper("company.byID"));
  const loyalty = useSelector(reduxStoreWrapper("loyalty.byID"));
  const user = useSelector(reduxStoreWrapper("user"));

  const [selectedRow, setSelectedRow] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [tabKey, setTabKey] = useState("all");
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const [isOpenAddGroup, setIsOpenAddGroup] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoad, setIsLoad] = useState(true);

  // counting the filtered data
  const statusText = {
    all: "all",
    created: 1,
    active: 2,
    suspended: 3,
    terminated: 0,
  };

  useEffect(() => {
    if (user.uroleid === "A") { 
      batch(() => {
        dispatch(REDUX_ACTION.v1_employee.get_all_employee_request());
        dispatch(REDUX_ACTION.v1_loyalty.get_all_loyalty_request());
      });
    } else {
      if (user.uroleid === "EMR") {
        batch(() => {
          dispatch(
            REDUX_ACTION.v1_employee.get_all_employee_by_coid_request(user.coid)
          );
          dispatch(REDUX_ACTION.v1_company.get_all_company_request());
          dispatch(REDUX_ACTION.v1_loyalty.get_all_loyalty_request());
        });
      }
      setIsLoad(false)
    }
    // return () => {};
  }, [dispatch, user.uroleid, isLoad]);

  useEffect(() => {
    dispatch(REDUX_ACTION.v1_group.get_all_group_request());
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    const objectValues = user?.uroleid === "A" ? employees : employeesCoid;

      const updatedEmployee = Object.values(objectValues).map((t) => {
        const coid = t.coid?.trim();
        const ltyid = t.loyaltyTier?.split("#");
        const cp = company[coid];
        const grp = group[t.groupid];
        const lty = loyalty[ltyid?.[0]];
        return {
          ...t,
          key: t.memid,
          status: t.status ?? 1,
          groupName: grp?.name,
          groupColor: grp?.color,
          company_name: cp?.name,
          loyalty: lty && Object.values(lty).length ? lty : {},
        };
      });
      setEmployee(updatedEmployee);
   
  }, [employees, group, company, loyalty]);

  useEffect(() => {
    if (employee.length > 0)
      setFilteredData(tableHDLR.dataTableSorting(employee));
  }, [employee]);

  const handleTab = (key) => {
    setTabKey(key);
    setCurrent(1);
  };
  
  const filteredDataCount = tableHDLR.dataCount(statusText, filteredData);

  useEffect(() => {
    if(filteredData.length){
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const newData = tableHDLR.datasourceFilter(filteredData, tabKey) ?? []
    const slicedData = newData.slice(startIndex, endIndex);

      setPaginatedData(slicedData);
    }
  }, [current, pageSize, filteredData, tabKey]);

  const handlePageChange = (newData) => {
    const sortedData = tableHDLR.dataTableSorting(newData);
    if (user.uroleid === "A") {
      // if (isFiltered === true) {
      setPaginatedData(sortedData);
      // }
    } else {
      setPaginatedData(sortedData);
    }
  };

  const exportData = selectedRow.length > 0 ? selectedRow : filteredData

  const template = EMPLOYEE_SUMMARY_COL({
    exportState: true,
    redux: {
      group,
      user,
    },
  });

  const extraButton = (
    <BtnSubmit
      display="inline-block"
      text="Export"
      bgColor="transparent"
      color="#4CAF50"
      padding="9px 18px"
      onClick={() =>
        exportHDLR.exportWithTemplate({
          data: exportData,
          filename: `EmployeeSummary_${parseExportTime()}`,
          template: template,
        })
      }
      showIcon={true}
      icon={BTN_IMG.EXPORT}
      icon_alt={"export"}
    />
  );

  return (
    <>
      <div
        className={styles.container}
        style={{ width: col ? "80vw" : "73vw" }}
      >
        <TableList.FilterData
          isModalOpen={isModalOpen}
          setIsModalOpen={() => setIsModalOpen(false)}
          selectOptions={filterOptions(user.uroleid)}
          groupOptions={groupOptions(group)}
          filteredData={tableHDLR.datasourceFilter(employee, tabKey)}
          setFilteredData={setFilteredData}
          tabKey={tabKey}
          setIsFiltered={setIsFiltered}
          statusText={statusText}
        />
        <SearchEmployee
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          pageSize={pageSize}
          setPageSize={setPageSize}
          tabKey={tabKey}
          current={current}
          setCurrent={setCurrent}
          handlePaginatedDataChange={handlePageChange}
          filteredDataCount={filteredDataCount}
          data={filteredData}
          setIsOpenAdd={setIsOpenAdd}
          setIsOpenAddGroup={setIsOpenAddGroup}
          isFiltered={isFiltered}
          user={user}
        />
        <div style={{ marginTop: "3.5em" }}>
          <Tabs
            tabBarExtraContent={extraButton}
            onTabClick={handleTab}
            items={TableItems(
              filteredDataCount,
              employee,
              filteredData,
              paginatedData,
              tabKey,
              setFilteredData,
              selectedRow,
              setSelectedRow,
              isFiltered,
              setIsModalOpen,
              isLoad
            )}
          />

          <DrawerAddEmployee isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} />
          <DrawerAddGroup
            isOpen={isOpenAddGroup}
            setIsOpen={setIsOpenAddGroup}
          />
        </div>
      </div>
    </>
  );
};

export default EmployeeList;
